<template>
  <div class="app-stepper">
    <div v-if="showPrev" class="btn-prev-overlay">
      <div v-if="loadingPrev" class="spinner"></div>
      <button :disabled="disabledPrev" @click="$emit('prev')" class="button button--secondary" type="button">
        <slot name="btnPrev"> {{ textPrev }}</slot>
      </button>
    </div>
    <slot name="betweenPrevNextButtons"></slot>
    <div v-if="showNext" class="btn-next-overlay">
      <div v-if="loadingNext" class="spinner"></div>
      <button :disabled="disabledNext" @click="$emit('next')" class="button button--primary" type="button">
        <slot name="btnNext">{{ textNext }}</slot>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stepper',
  props: {
    loadingPrev: {
      type: Boolean,
      default: false
    },
    loadingNext: {
      type: Boolean,
      default: false
    },
    disabledPrev: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    },
    textNext: {
      type: String,
      default: 'Weiter'
    },
    textPrev: {
      type: String,
      default: 'Zurück'
    }
  }
}
</script>
